import { ArrowRight } from '@phosphor-icons/react';
import { ReactNode } from 'react';
import { useNotificationBannerStyles } from './NotificationBanner.styles';
import { useNotificationBannerPosition } from './useNotificationBannerPosition';

export type NotificationBannerProps = {
  label: ReactNode;
  actionLabel: string;
  onClick?: () => void;
  count?: number;
  /** Adds in-flow space on mobile so the overlay does not cover page content. */
  reserveMobileSpace?: boolean;
};

const NotificationBanner = ({
  label,
  actionLabel,
  onClick,
  count,
  reserveMobileSpace = true,
}: NotificationBannerProps) => {
  const classes = useNotificationBannerStyles();
  const { top, isVisible, isNarrow } = useNotificationBannerPosition();

  if (!isVisible) {
    return null;
  }

  return (
    <>
      {reserveMobileSpace && isNarrow && (
        <div className={classes.mobileSpace} aria-hidden="true" />
      )}
      <button type="button" className={classes.banner} style={{ top }} onClick={onClick}>
        <span className={classes.label}>
          {label}
          {count != null && <span className={classes.count}>{count}</span>}
        </span>
        <span className={classes.action}>
          {actionLabel}
          <ArrowRight className={classes.icon} aria-hidden="true" />
        </span>
      </button>
    </>
  );
};

export default NotificationBanner;
